import axios from "axios";

axios.defaults.validateStatus = () => true;

export const apiCarcerario = axios.create({
  baseURL: process.env.REACT_APP_URL_CARCERARIO,
});

export function getCarcerario(DET_ID: string) {
  const storedToken = sessionStorage.getItem("@webSDS:token");
  const response = apiCarcerario.get("/carcerarioInfo", {
    headers: {
      Authorization: `Bearer ${storedToken}`,
      det_id: DET_ID,
    },
  });

  return response;
}

export function getFoto(DET_ID: string) {
  const storedToken = sessionStorage.getItem("@webSDS:token");
  const response = apiCarcerario.get(`foto/${DET_ID}`, {
    headers: {
      Authorization: `Bearer ${storedToken}`,
    },
  });

  return response;
}
